export const BOT_REVIEW_COMPONENT_TYPES = {
  question: 'question',
  intent: 'intent',
}
